import { useOnMount } from '@wyz/utils';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectField } from '~/common/components';
import { useLocale } from '~/common/context';
type SelectLanguageProps = {
  name: string;
  label: React.ReactNode;
  mode: string;
  required?: boolean;
};
export const SelectLanguage = ({
  name,
  label,
  required = false,
  mode,
}: SelectLanguageProps) => {
  const methods = useFormContext();
  const { languages } = useLocale();
  useOnMount(() => {
    if (mode === 'CREATE') {
      methods.setValue(name, languages.byIndex.at(0)?.isoCode);
    }
  });

  return (
    <>
      <SelectField
        name={name}
        label={label}
        options={languages.byIndex.map((language) => ({
          label: language.humanName,
          value: language.isoCode,
        }))}
        isClearable
        required={required}
      />
    </>
  );
};
